import React from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { darkColors } from "../../../theme/colors";
import { fontSizes } from "../../../theme/font-sizes";
import XIcon from "@mui/icons-material/X"; // Replace with the correct icon import if needed
import { assetIcons } from "../../../constants/assets";
import { socialRedirectUrls } from "../../../constants/urls";
import FacebookIcon from "@mui/icons-material/Facebook";
const ImageOverlayText = ({ imageUrl, isMediumScreen, children }) => {
  return (
    <Box
      sx={{
        position: "relative",
        zIndex: 1,
        paddingLeft: isMediumScreen ? 0 : "2.1%",
        display: "flex",
        flexDirection: "column",
        alignItems: isMediumScreen ? "center" : "flex-start",
      }}
    >
      {isMediumScreen && (
        <Typography
          sx={{
            color: darkColors.buttonTop,
            border: "1px solid white",
            borderRadius: "20px",
            mt: 2,
            padding: "4px 34px",
            fontSize: fontSizes.info,
            fontFamily: "MontserratBold",
            marginBottom: 2,
            textTransform: "uppercase",
            background: "#151515",
          }}
        >
          Special Event
        </Typography>
      )}

      <Typography
        fontFamily={"MontserratBold"}
        sx={{
          color: "white",
          mb: 1,
          textTransform: isMediumScreen ? "none" : "uppercase",
          fontSize: isMediumScreen
            ? fontSizes.superHeading5
            : "clamp(24px, 2vw, 42px)",
          textAlign: isMediumScreen ? "center" : "left",
        }}
      >
        Join the <span style={{ color: darkColors.orange }}>Community</span>
      </Typography>

      <Typography
        sx={{
          color: "#BEBEBE",
          fontSize: "clamp(12px, 1.2vw, 18px)",
          textAlign: isMediumScreen ? "center" : "left",
          maxWidth: isMediumScreen ? "280px" : "none",
          margin: isMediumScreen ? "0 auto" : "0",
        }}
      >
        Follow us for the latest updates, events, and exclusive rewards
      </Typography>

      <Box
        sx={{
          mt: 2,
          display: "flex",
          justifyContent: isMediumScreen ? "center" : "flex-start",
          width: "100%",
          gap: 1,
        }}
      >
        <IconButton
          size="small"
          sx={{ color: darkColors.socialIconsGray }}
          onClick={() => window.open(socialRedirectUrls.discord, "_blank")}
        >
          <img src={assetIcons.discord} alt="discord" />
        </IconButton>
        <IconButton
          size="small"
          sx={{ color: darkColors.socialIconsGray }}
          onClick={() => window.open(socialRedirectUrls.facebook, "_blank")}
        >
          <FacebookIcon />
        </IconButton>
        <IconButton
          size="small"
          sx={{ color: darkColors.socialIconsGray }}
          onClick={() => window.open(socialRedirectUrls.twitter, "_blank")}
        >
          <XIcon />
        </IconButton>
        <IconButton
          size="small"
          sx={{ color: darkColors.primary }}
          onClick={() => window.open(socialRedirectUrls.tiktok, "_blank")}
        >
          <img src={assetIcons.tiktok} alt="tiktok" width={30} height={30} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ImageOverlayText;
